import algoliasearch from 'algoliasearch'
import instantsearch from 'instantsearch.js'
import { configure } from 'instantsearch.js/es/widgets'
import { applyFilters } from '@wordpress/hooks';


if(!window.tangibleAlgoliaInstances) window.tangibleAlgoliaInstances = {} 

//TODO:
// Test what happens when this tries to create a index that doesn't exist so we can handle the error
const getInstance = (indexId) => {
  if ( window.tangibleAlgoliaInstances[indexId] ) {
    return window.tangibleAlgoliaInstances[indexId]
  }

  const tgblAlgoliaDataJSON = window.atob(tgblAlgoliaDataEncoded);
  const tgblAlgoliaData = jQuery.parseJSON(tgblAlgoliaDataJSON);

  const searchClient = algoliasearch(
    tgblAlgoliaData.app_id, 
    tgblAlgoliaData.search_key
  )

  // Forward WordPress ?s= query as the initial Algolia search term.
  const wpQuery = new URLSearchParams(window.location.search).get('s') ?? '';

  const searchInstance = instantsearch({
    indexName: indexId,
    searchClient,
    routing: true,
    initialUiState: wpQuery ? { [indexId]: { query: wpQuery } } : undefined,
  });

  searchInstance.addWidgets([
    configure({}),
  ])

  window.tangibleAlgoliaInstances[indexId] = searchInstance;
  return window.tangibleAlgoliaInstances[indexId]
}

const registerWidget = element => {

  element.setAttribute('data-init', "true")

  /**
   * If all the elements are registered we init the instances
   */
  const elements = document.querySelectorAll("[data-init]")

  let hasUninitialized = false
  elements.forEach(element => {
    if(element.getAttribute('data-init') === 'true') return;
    hasUninitialized = true
  })

  if(hasUninitialized === true) return

  for(const key in window.tangibleAlgoliaInstances) {
    window.tangibleAlgoliaInstances[key].start()
  }

  // After start, collect the preselection plan from filters and apply it
  if (!window.tangibleAlgoliaPreselectApplied) {
    const preselectionPlan = applyFilters('tangible-algolia-preselect-refinement', []);
    // preselectionPlan: [{ indexName, attribute, values: [] }, ...]

    preselectionPlan.forEach(({ indexName, attribute, values, value, widgetType }) => {
      const search = window.tangibleAlgoliaInstances[indexName];
      if (!search || !search.helper) return;

      if ( widgetType === 'menu' || widgetType === 'menu_select' ) {
        if ( value ) {
          search.renderState[indexName].menu[attribute].refine(value);
          search.helper.search();
        }
      } else {
        if (!Array.isArray(values)) return;
        values.forEach((preselectedRefinement) => {
          search.renderState[indexName].refinementList[attribute].refine(preselectedRefinement);
        });
        search.helper.search();
      }
    });

    window.tangibleAlgoliaPreselectApplied = true;
  }

  // Optional: event for other consumers
  const event = new CustomEvent('algoliaInstanceCreated', {});
  window.dispatchEvent(event);
};

export {getInstance, registerWidget}